import * as pdfjsLib from 'pdfjs-dist'

// Worker URL is pinned to the installed package version so the two can never
// drift (pdfjs refuses to load a mismatched worker).
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`

// v6 moved the JBIG2/CCITT-fax image decoders out of the bundled pure-JS code
// and into WASM modules that pdfjs fetches on demand from `wasmUrl`. Every
// `getDocument()` call must pass this, or those decoders silently fail and
// CCITT-fax/JBIG2 images (common in faxed/scanned healthcare documents) render
// as black boxes instead of erroring. cdnjs's pdf.js mirror (used above for the
// worker) does not publish the package's `wasm/` folder, so this is pinned to
// jsDelivr's npm mirror instead, which serves the full npm file tree. Pinned
// to the installed version, same as the worker.
export const PDF_WASM_URL = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/wasm/`

export { pdfjsLib }
